export const personalContact = [
  {
    icon: <i className="fas fa-envelope"></i>,
    value: <a href="mailto:samatova.vodelina@gmail.com">samatova.vodelina@gmail.com</a>,
    preferred: true
  }
];